// extracted by mini-css-extract-plugin
module.exports = {"container":"NoPurchasesMessage_container__MCj7o","link":"NoPurchasesMessage_link__WyCkr","content":"NoPurchasesMessage_content__Owel4"};